import * as React from 'react';
import styles from './index.less';
import * as semver from 'semver';
// import * as AHooks from 'ahooks';
import FComponentsLib from '@freelog/components-lib';
import { FI18n, FUtil } from '@freelog/tools-lib';
import FIcons from '@/components/FIcons';
import FInput_PinyinSafeTextCounter from '../FInput_PinyinSafeTextCounter';

interface VersionInputProps {
  value: string;
  resourceLatestVersion: string;

  onChange?(value: string): void;

  onChangeError?(hasError: boolean): void;
}

interface VersionInputStates {
  $isEdit: boolean;
  $input: string;
  $inputError: string;
}

const initStates: VersionInputStates = {
  $isEdit: false,
  $input: '',
  $inputError: '',
};

function VersionInput({
  value,
  resourceLatestVersion,
  onChange,
  onChangeError,
}: VersionInputProps) {
  const [$isEdit, set$isEdit] = FUtil.Hook.useGetState<VersionInputStates['$isEdit']>(
    initStates['$isEdit'],
  );
  const [$input, set$input, get$input] = FUtil.Hook.useGetState<VersionInputStates['$input']>(
    initStates['$input'],
  );
  const [$inputError, set$inputError, get$inputError] = FUtil.Hook.useGetState<
    VersionInputStates['$inputError']
  >(initStates['$inputError']);

  return (
    <div className={styles.VersionInput}>
      {!$isEdit ? (
        <div className={styles.noEdit}>
          <FComponentsLib.FContentText
            text={
              value
                ? `${FI18n.i18nNext.tAuto('create_new_version_versionno')} ${value}`
                : FI18n.i18nNext.tAuto('unamed_version')
            }
            type={'highlight'}
          />
          <FComponentsLib.FTextBtn
            type={'primary'}
            onClick={() => {
              set$input(value);
              set$inputError('');
              set$isEdit(true);
            }}
          >
            <FIcons.FEdit style={{ fontSize: 20 }} />
          </FComponentsLib.FTextBtn>
        </div>
      ) : (
        <>
          <div className={styles.versionInput}>
            <FInput_PinyinSafeTextCounter
              lengthLimit={-1}
              value={$input}
              onChangeValue={(v) => {
                const inputValue: string = v;
                let inputValueError: string = '';
                if (inputValue === '') {
                  inputValueError =
                    // 请输入版本号
                    FI18n.i18nNext.tAuto('naming_convention_version_required');
                } else if (!semver.valid(inputValue)) {
                  inputValueError =
                    // '版本号不合法';
                    FI18n.i18nNext.tAuto('freelog_versioning');
                } else if (!semver.gt(inputValue, resourceLatestVersion || '0.0.0')) {
                  inputValueError = FI18n.i18nNext.tAuto('freelog_versioning', {
                    version: resourceLatestVersion || '0.0.0',
                  });
                }
                set$input(inputValue);
                set$inputError(inputValueError);
                onChangeError && onChangeError(inputValueError !== '');
              }}
              className={styles.FInputFSingleLine}
            />
            <div style={{ width: 20 }} />
            <FComponentsLib.FTextBtn
              type={'default'}
              style={{ fontSize: 12 }}
              onClick={() => {
                set$isEdit(false);
                onChangeError && onChangeError(false);
              }}
            >
              {/* 取消 */}
              {FI18n.i18nNext.tAuto('btn_cancel')}
            </FComponentsLib.FTextBtn>
            <div style={{ width: 10 }} />
            <FComponentsLib.FTextBtn
              type={'primary'}
              disabled={$inputError !== ''}
              style={{ fontSize: 12 }}
              onClick={() => {
                onChange && onChange(get$input());
                set$isEdit(false);
              }}
            >
              {/* 保存 */}
              {FI18n.i18nNext.tAuto('btn_save')}
            </FComponentsLib.FTextBtn>
          </div>
          <div style={{ height: 5 }} />
          <div className={styles.error}>{$inputError}</div>
        </>
      )}
    </div>
  );
}

export default VersionInput;
